import { getAxiosInstance } from "./axiosInstance";

const uploadFactoryStock = (formData) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/stock/factory/upload/",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
};

const factoryStockList = (data) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/stock/factory/list/",
    data
  );
};

const deleteFactoryStock = (data) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/stock/factory/delete/",
    data
  );
};
const untaggedIMEI = (data) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/stock/factory/untag/",
    data
  );
};

const sendBootstrapRequest = (data) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/stock/factory/bootstrap-request/",
    data,
    {
      responseType: "blob",
    }
  );
};

/* ============================
   Device Config Console APIs
============================ */

/**
 * List Devices
 */
const configList = (data) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/stock/config/list/",
    data
  );
};

/**
 * Vendor / Model / Protocol Dropdown
 */
const getFotaOptions = () => {
  const http = getAxiosInstance();

  return http.get(
    "/api/stock/config/fota-options/"
  );
};

const getVendorManufacturerCatalog = (vendorId = "MAPW") => {
    const http = getAxiosInstance();

    return http.get(
        `/api/stock/config/vendor-manufacturer-catalog/?vendor_id=${vendorId}`
    );
};

/**
 * Step 1
 * Send FOTA
 */
const sendFota = (data) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/stock/config/fota/send/",
    data
  );
};

/**
 * Step 2
 * Refresh FOTA Status
 */
const refreshFotaStatus = (data) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/stock/config/fota/refresh-status/",
    data
  );
};

/**
 * Step 3
 * Send Config Commands
 */
const sendConfig = (data) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/stock/config/send-config/",
    data
  );
};

/**
 * Verify Device Connectivity
 */
const verifyConnectivity = (data) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/stock/config/verify-connectivity/",
    data
  );
};
/**
 * Step 4
 * Check Config
 */
const checkConfig = (data) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/stock/config/check-config/",
    data
  );
};

/**
 * Mark Configuration Done
 */
const markConfigDone = (data) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/stock/config/mark-done/",
    data
  );
};

/**
 * Command History
 */
const getCommandHistory = (imei) => {
  const http = getAxiosInstance();

  return http.get(
    `/api/stock/config/command-history/?imei=${imei}`
  );
};

/* ============================
   Factory Dispatch APIs
============================ */

/**
 * List Config Done Undispatched Stock
 */
const dispatchStockList = (data) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/stock/dispatch/list/",
    data
  );
};

/**
 * Dealer Dropdown
 */
const dispatchDealerList = (data) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/stock/dispatch/dealers/",
    data
  );
};

/**
 * Dispatch Stock
 */
const dispatchStock = (data) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/stock/dispatch/send/",
    data
  );
};

/**
 * ============================
 * Bulk FOTA Queue APIs
 * ============================
 */

/**
 * Add selected devices to FOTA Queue
 * POST /api/stock/config/fota/queue/add/
 */
const fotaQueueAdd = (data) => {
    const http = getAxiosInstance();

    return http.post(
        "/api/stock/config/fota/queue/add/",
        data
    );
};

/**
 * Get FOTA Queue Status
 * GET /api/stock/config/fota/queue/status/
 */
const fotaQueueStatus = () => {
    const http = getAxiosInstance();

    return http.get(
        "/api/stock/config/fota/queue/status/"
    );
};

/**
 * Mark Config Done for selected ready devices
 * POST /api/stock/config/fota/queue/mark-done/
 */
const fotaQueueMarkDone = (data) => {
    const http = getAxiosInstance();

    return http.post(
        "/api/stock/config/fota/queue/mark-done/",
        data
    );
};

/**
 * Retry failed/error FOTA queue devices
 * POST /api/stock/config/fota/queue/retry/
 */
const fotaQueueRetry = (data) => {
    const http = getAxiosInstance();

    return http.post(
        "/api/stock/config/fota/queue/retry/",
        data
    );
};

//Device Feature
// Create device feature 
const createDeviceFeature = (data) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/stock/device-feature/create/",
    data
  );
};

// Updates Device Features
const updateDeviceFeature = (data) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/stock/device-feature/update/",
    data
  );
};

//Delete Device Feature
const softDeleteDeviceFeature = (data) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/stock/device-feature/soft-delete/",
    data
  );
};

// List Device Feature
const deviceFeatureList = (data = {}) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/stock/device-feature/list/",
    data
  );
};

//Bulk Assign Device feature
const assignDeviceFeature = (data) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/stock/device-feature/assign/",
    data
  );
};

//Device feature filter options
const deviceFeatureFilterOptions = (data = {}) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/stock/device-feature/filter-options/",
    data
  );
};

const FactoryStockService = {
  uploadFactoryStock,
  factoryStockList,
  deleteFactoryStock,
  sendBootstrapRequest,

  configList,
  getFotaOptions,
  sendFota,
  refreshFotaStatus,
  sendConfig,
  checkConfig,
   verifyConnectivity, 
  markConfigDone,
  getCommandHistory,

  dispatchStockList,
  dispatchDealerList,
  dispatchStock,
  getVendorManufacturerCatalog,

   // Bulk FOTA Queue APIs
    fotaQueueAdd,
    fotaQueueStatus,
    fotaQueueMarkDone,
    fotaQueueRetry,

    untaggedIMEI,

    // Device Feature APIs
  createDeviceFeature,
  updateDeviceFeature,
  softDeleteDeviceFeature,
  deviceFeatureList,
  deviceFeatureFilterOptions,
  assignDeviceFeature
};

export default FactoryStockService;